import { events, screen } from "./eventName";

export function cancatCategory(screenName, eventName) {
  // console.log('----cancatCategory----->', screenName, eventName);
  // const concated = screen[screenName] + "_" + events[eventName];
  const concated = screenName + "_" + eventName;
  // console.log('--------concated------>', concated);
  return concated;
}

export function concatCallCategory(screenName, eventName) {
  // console.log('----cancatCategory----->', screenName, eventName);
  const concated = screenName + "_" + events[eventName];
  // console.log('--------concated------>', concated);
  return concated;
}
